const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/VersionInfo.tsx';
import { css } from '@emotion/css';
import { VERSION, VERSION_SUB } from 'App/defs/defs';
import * as React from 'react';
import { colors } from '@cistec/common_web/defs/colors';

const cssVersionInfo = css`
    bottom: 3px;
    right: 3px;
    color: ${colors.grey['600']};
    opacity: 0.4;
    padding: 4px;
    font-size: 10px;
    z-index: 9000; // above the Redux panel
`;

export const VersionInfo = () => {
    return <span className={cssVersionInfo}>v{VERSION + '' + VERSION_SUB}</span>;
};
